import { codeToText, regionData } from 'element-china-area-data'

const virtualCityPattern = /^(市辖区|县|省直辖县级行政区划|自治区直辖县级行政区划)$/

export function normalizeAreaCodes(value) {
  const source = (Array.isArray(value) ? value : String(value || '').split(',')).map(item => String(item || '').trim()).filter(Boolean)
  const leaf = source.slice().reverse().find(code => /^(\d{6}|\d{9})$/.test(code) && codeToText[code])
  if (leaf) {
    const codes = [leaf.slice(0, 2), leaf.slice(0, 4), leaf].filter(code => codeToText[code])
    if (codes.length) return codes
  }
  const city = source.slice().reverse().find(code => /^\d{4}$/.test(code))
  if (city && codeToText[city]) return [city.slice(0, 2), city].filter(code => codeToText[code])
  const province = source.find(code => /^\d{2}$/.test(code) && codeToText[code])
  return province ? [province] : source.filter(code => codeToText[code])
}

export function getAreaName(codes) {
  return normalizeAreaCodes(codes).map(code => codeToText[code] || '').filter(Boolean).join('')
}

export function getAreaCodesByAddress(value) {
  const text = String(value || '').replace(/\s+/g, '')
  const province = regionData.find(item => text.startsWith(item.label))
  if (!province) return []
  const afterProvince = text.slice(province.label.length)
  for (const city of province.children || []) {
    const virtualCity = virtualCityPattern.test(city.label)
    if (!virtualCity && !afterProvince.startsWith(city.label)) continue
    const afterCity = afterProvince.startsWith(city.label) ? afterProvince.slice(city.label.length) : afterProvince
    const district = (city.children || []).find(item => afterCity.startsWith(item.label))
    if (district) return [province.value, city.value, district.value]
  }
  return []
}

export function naturalAreaName(value) {
  const text = String(value || '')
  const province = regionData.find(item => text.startsWith(item.label))
  if (!province) return text
  const afterProvince = text.slice(province.label.length)
  // 仅省级之后的虚拟层可省略，真实县名和详细地址中的相同文字必须保留。
  const city = (province.children || []).find(item => virtualCityPattern.test(item.label) && afterProvince.startsWith(item.label))
  return city ? `${province.label}${afterProvince.slice(city.label.length)}` : text
}

export function stripAreaPrefix(address, areaName) {
  const text = String(address || '').trim()
  const prefixes = [areaName, naturalAreaName(areaName)].filter(Boolean)
  const prefix = prefixes.find(item => text.startsWith(item))
  return prefix ? text.slice(prefix.length).trim() : text
}

export function buildFullAddress(codes, address) {
  const areaName = getAreaName(codes)
  const detailAddress = stripAreaPrefix(address, areaName)
  return `${naturalAreaName(areaName)}${detailAddress}`
}

export function getAreaCodesByAdcode(adcode, component = {}) {
  const code = String(adcode || '')
  if (!/^\d{6}$/.test(code)) return []
  // 东莞等不设区城市使用街镇作为第三级，必须匹配真实街镇，不能伪造区县。
  if (!codeToText[code]) {
    const townCode = String(component.towncode || '').slice(0, 9)
    if (townCode.startsWith(code.slice(0, 4)) && codeToText[townCode]) return normalizeAreaCodes(townCode)
    const province = regionData.find(item => item.value === code.slice(0, 2))
    const city = province && province.children.find(item => item.value === code.slice(0, 4))
    const town = city && city.children && city.children.find(item => item.value.length === 9 && item.label === component.township)
    if (town) return normalizeAreaCodes(town.value)
  }
  return [code.slice(0, 2), code.slice(0, 4), code].filter(item => codeToText[item])
}

export function getDetailAddress(address, component, areaCodes) {
  const text = String(address || '').trim()
  const getText = value => Array.isArray(value) ? value.join('') : String(value || '')
  const province = getText(component && component.province)
  const city = getText(component && component.city)
  const district = getText(component && component.district)
  const prefixes = [getAreaName(areaCodes), `${province}${city}${district}`, `${province}${district}`, `${province}${city}`, province]
    .filter(Boolean)
    .sort((left, right) => right.length - left.length)
  const prefix = prefixes.find(item => text.startsWith(item))
  return prefix ? text.slice(prefix.length).trim() : text
}
